module.exports = __webpack_public_path__ + "media/assets/svgs/loginBackground-3a4a77add031b4904b25b295735e5805.svg";